import { Navigate, useNavigate, useParams } from "react-router-dom";
import { connect } from "react-redux";
import React, { useEffect, useState } from "react";
import SideNav from "../../../../components/dashboard/Sidebar";
import { get_product_detail } from "../../../../redux/actions/products";
import { get_categories } from "../../../../redux/actions/categories";
import axios from "axios";
import { setAlert } from "../../../../redux/actions/alert";

function DashboardStoreProductEdit({
  isAuthenticated,
  get_product_detail,
  product,
  get_categories,
  categories,
  setAlert,
}) {
  const params = useParams();
  const id = params.id;
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: "",
    price: "",
    compare_price: "",
    description: "",
    category: "",
    type: "",
    condition: "",
    size: "",
    color: "",
    material: "",
    brand: "",
    quantity: "",
    active: false,
    images: [],
  });

  const [photos, setPhotos] = useState([]);
  const [errors, setErrors] = useState({
    name: "",
    price: "",
    compare_price: "",
    description: "",
    category: "",
    type: "",
    condition: "",
    size: "",
    color: "",
    material: "",
    brand: "",
    quantity: "",
    photos: "",
    active: "",
  });

  const {
    name,
    price,
    compare_price,
    description,
    category,
    type,
    condition,
    size,
    color,
    material,
    brand,
    quantity,
    active,
    images,
  } = formData;

  useEffect(() => {
    if (isAuthenticated) {
      get_product_detail(id);
      get_categories();
    }
  }, [get_product_detail, get_categories, isAuthenticated, id]);

  useEffect(() => {
    if (product) {
      setFormData({
        name: product.name || "",
        price: product.price || "",
        compare_price: product.compare_price || "",
        description: product.description || "",
        category: product.category_detail.id || "",
        type: product.type || "",
        condition: product.condition || "",
        size: product.size || "",
        color: product.color || "",
        material: product.material || "",
        brand: product.brand || "",
        quantity: product.quantity || "",
        active: product.active || false,
        images: product.images || [],
      });
    }
  }, [product]);

  const validateForm = () => {
    let formIsValid = true;
    const newErrors = {
      name: "",
      price: "",
      compare_price: "",
      description: "",
      category: "",
      type: "",
      condition: "",
      size: "",
      color: "",
      material: "",
      brand: "",
      quantity: "",
      photos: "",
      active: "",
    };

    if (!name.trim()) {
      newErrors.name = "El nombre del producto es obligatorio.";
      formIsValid = false;
    }

    if (!price || isNaN(price) || parseFloat(price) <= 0) {
      newErrors.price = "El precio debe ser un número mayor a 0.";
      formIsValid = false;
    }

    if (
      !compare_price ||
      isNaN(compare_price) ||
      parseFloat(compare_price) <= 0
    ) {
      newErrors.compare_price =
        "El precio comparativo debe ser un número mayor a 0.";
      formIsValid = false;
    }

    if (!description.trim()) {
      newErrors.description = "La descripción es obligatoria.";
      formIsValid = false;
    }

    if (!category) {
      newErrors.category = "La categoría es obligatoria.";
      formIsValid = false;
    }

    if (!quantity || isNaN(quantity) || parseInt(quantity) < 0) {
      newErrors.quantity = "La cantidad debe ser un número mayor o igual a 0.";
      formIsValid = false;
    }

    if (photos.length === 0 && images.length === 0) {
      newErrors.photos = "Al menos una imagen es obligatoria.";
      formIsValid = false;
    }

    setErrors(newErrors);
    return formIsValid;
  };

  const onChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
    setErrors({
      ...errors,
      [name]: "",
    });
  };

  const onFileChange = (e) => {
    const selectedFiles = Array.from(e.target.files);
    setPhotos(selectedFiles);
    const urls = selectedFiles.map((file) => URL.createObjectURL(file));
    setFormData({
      ...formData,
      images: urls,
    });
    setErrors({
      ...errors,
      photos: "",
    });
  };

  const onSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    const config = {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `JWT ${localStorage.getItem("access")}`,
      },
    };

    const formDataToSubmit = new FormData();
    formDataToSubmit.append("name", name);
    formDataToSubmit.append("price", price);
    formDataToSubmit.append("compare_price", compare_price);
    formDataToSubmit.append("description", description);
    formDataToSubmit.append("category", category);
    formDataToSubmit.append("type", type);
    formDataToSubmit.append("condition", condition);
    formDataToSubmit.append("size", size);
    formDataToSubmit.append("color", color);
    formDataToSubmit.append("material", material);
    formDataToSubmit.append("brand", brand);
    formDataToSubmit.append("quantity", quantity);
    formDataToSubmit.append("active", active);

    photos.forEach((photo) => {
      formDataToSubmit.append("images", photo);
    });

    try {
      const response = await axios.put(
        `${process.env.REACT_APP_API_URL}/api/product/products/update/${id}/`,
        formDataToSubmit,
        config,
      );

      if (response.status === 200) {
        setAlert("Producto actualizado correctamente", "green");
        navigate("/dashboard/products");
      } else {
        setAlert("Error al actualizar el producto", "red");
      }
    } catch (err) {
      console.error(err);
      setAlert("Error al actualizar el producto", "red");
    }
  };

  if (!isAuthenticated) return <Navigate to="/" />;

  console.log(product);
  return (
    <SideNav>
      <div className="container mx-auto px-4 sm:px-8">
        <h1 className="text-2xl font-semibold text-gray-900 mt-4">
          Editar Producto
        </h1>
        <div className="mt-8">
          <form onSubmit={onSubmit} className="max-w-3xl mx-auto">
            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  Nombre del Producto
                </label>
                <input
                  type="text"
                  name="name"
                  value={name}
                  onChange={onChange}
                  className="appearance-none block w-full px-3 py-2 border rounded-md shadow-sm"
                />

                {errors.name && (
                  <p className="text-sm text-red-500">{errors.name}</p>
                )}
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  Precio
                </label>
                <input
                  type="text"
                  name="price"
                  value={price}
                  onChange={onChange}
                  className="appearance-none block w-full px-3 py-2 border rounded-md shadow-sm"
                />

                {errors.price && (
                  <p className="text-sm text-red-500">{errors.price}</p>
                )}
              </div>
            </div>
            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  Precio Comparativo
                </label>
                <input
                  type="text"
                  name="compare_price"
                  value={compare_price}
                  onChange={onChange}
                  className="appearance-none block w-full px-3 py-2 border rounded-md shadow-sm"
                />

                {errors.compare_price && (
                  <p className="text-sm text-red-500">{errors.compare_price}</p>
                )}
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  Cantidad
                </label>
                <input
                  type="text"
                  name="quantity"
                  value={quantity}
                  onChange={onChange}
                  className="appearance-none block w-full px-3 py-2 border rounded-md shadow-sm"
                />

                {errors.quantity && (
                  <p className="text-sm text-red-500">{errors.quantity}</p>
                )}
              </div>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Descripción
              </label>
              <textarea
                name="description"
                value={description}
                onChange={onChange}
                rows="4"
                className="appearance-none block w-full px-3 py-2 border rounded-md shadow-sm"
              />

              {errors.description && (
                <p className="text-sm text-red-500">{errors.description}</p>
              )}
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Categoría
              </label>
              <select
                name="category"
                value={category}
                onChange={onChange}
                className="appearance-none block w-full px-3 py-2 border rounded-md shadow-sm"
              >
                <option value="">Seleccione una categoría</option>
                {categories &&
                  categories.map((cat) => (
                    <React.Fragment key={cat.id}>
                      <option value={cat.id}>{cat.name}</option>
                      {cat.sub_categories.map((subCat) => (
                        <option key={subCat.id} value={subCat.id}>
                          {cat.name} - {subCat.name}
                        </option>
                      ))}
                    </React.Fragment>
                  ))}
              </select>
              {errors.category && (
                <p className="text-sm text-red-500">{errors.category}</p>
              )}
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Tipo
              </label>
              <select
                name="type"
                value={type}
                onChange={onChange}
                className="appearance-none block w-full px-3 py-2 border rounded-md shadow-sm"
              >
                <option value="">Seleccione un tipo</option>
                <option value="clothing">Ropa</option>
                <option value="furniture">Muebles</option>
                <option value="jewelry">Joyería</option>
                <option value="art">Arte</option>
                <option value="books">Libros</option>
                <option value="electronics">Electrónica</option>
                <option value="collectibles">Coleccionables</option>
              </select>
              {errors.type && (
                <p className="text-sm text-red-500">{errors.type}</p>
              )}
            </div>
            {type === "clothing" && (
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  Tamaño
                </label>
                <select
                  name="size"
                  value={size}
                  onChange={onChange}
                  className="appearance-none block w-full px-3 py-2 border rounded-md shadow-sm"
                >
                  <option value="">Seleccione un tamaño</option>
                  <option value="small">Pequeño</option>
                  <option value="medium">Mediano</option>
                  <option value="large">Grande</option>
                  <option value="extra_large">Extra Grande</option>
                </select>
                {errors.size && (
                  <p className="text-sm text-red-500">{errors.size}</p>
                )}
              </div>
            )}
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Color
              </label>
              <input
                type="text"
                name="color"
                value={color}
                onChange={onChange}
                className="appearance-none block w-full px-3 py-2 border rounded-md shadow-sm"
              />

              {errors.color && (
                <p className="text-sm text-red-500">{errors.color}</p>
              )}
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Material
              </label>
              <input
                type="text"
                name="material"
                value={material}
                onChange={onChange}
                className="appearance-none block w-full px-3 py-2 border rounded-md shadow-sm"
              />

              {errors.material && (
                <p className="text-sm text-red-500">{errors.material}</p>
              )}
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Marca
              </label>
              <input
                type="text"
                name="brand"
                value={brand}
                onChange={onChange}
                className="appearance-none block w-full px-3 py-2 border rounded-md shadow-sm"
              />

              {errors.brand && (
                <p className="text-sm text-red-500">{errors.brand}</p>
              )}
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Imágenes
              </label>
              <input
                type="file"
                name="photos"
                multiple
                onChange={onFileChange}
                className="appearance-none block w-full px-3 py-2 border rounded-md shadow-sm"
              />

              {errors.photos && (
                <p className="text-sm text-red-500">{errors.photos}</p>
              )}
            </div>
            <div className="mt-4 grid grid-cols-3 gap-4">
              {images.map((imgObj, index) => (
                <img
                  key={index}
                  src={`${process.env.REACT_APP_API_URL}${imgObj.image}` || ""}
                  alt={`preview-${index}`}
                  style={{
                    width: "100px",
                    height: "100px",
                    objectFit: "cover",
                  }}
                />
              ))}
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700">
                Activo
              </label>
              <select
                name="active"
                value={active}
                onChange={onChange}
                className={`appearance-none block w-full px-3 py-2 border ${
                  errors.active ? "border-red-500" : "border-gray-300"
                } rounded-md shadow-sm`}
              >
                <option value="">Seleccione un estado</option>
                <option value="true">Activo</option>
                <option value="false">Inactivo</option>
              </select>
              {errors.active && (
                <p className="text-sm text-red-500">{errors.active}</p>
              )}
            </div>
            <button
              type="submit"
              className="mt-4 inline-flex items-center px-4 py-2 border rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700"
            >
              Guardar Cambios
            </button>
          </form>
        </div>
      </div>
    </SideNav>
  );
}

const mapStateToProps = (state) => ({
  isAuthenticated: state.Auth.isAuthenticated,
  product: state.ProductsFull.product,
  categories: state.Categories.categories,
});

export default connect(mapStateToProps, {
  get_product_detail,
  get_categories,
  setAlert,
})(DashboardStoreProductEdit);
